import { render } from "./Containers.vue?vue&type=template&id=349949e8&scoped=true"
import script from "./Containers.vue?vue&type=script&lang=js"
export * from "./Containers.vue?vue&type=script&lang=js"

import "./Containers.vue?vue&type=style&index=0&id=349949e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349949e8"]])

export default __exports__